import { render, staticRenderFns } from "./SegundaViaNascimento.vue?vue&type=template&id=56df4e68&"
import script from "./SegundaViaNascimento.vue?vue&type=script&lang=js&"
export * from "./SegundaViaNascimento.vue?vue&type=script&lang=js&"
import style0 from "./SegundaViaNascimento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports